import { removeUndefinedDeep } from './removeUndefinedDeep';

/** Firestore rejects nested `undefined` (for example overhead `costObject.dealId`). */
export function sanitizePurchaseWrite<T>(value: T): T {
  return removeUndefinedDeep(value);
}
